import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6908e271"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "reissue-type-wrap" }
const _hoisted_2 = { class: "reissue-type-list-wrap" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "right-wrap" }
const _hoisted_5 = { class: "reason-text" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "bottom-wrap xag-page__footer" }

import { Button, Icon, RadioGroup, Radio } from 'vant'
import SelectSvg from '@/assets/nameplate-reissue/select.svg'
import { computed, withDefaults } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'product-number-type-list',
  props: {
    data: null,
    checked: null
  },
  emits: ["confirm", "update:checked"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'confirm', value: string): void
  (event: 'update:checked', value: string): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { data: Array<{
      label: string
      value: string
    }>, checked: string };




let checked = computed({
  get() {
    return props.checked
  },
  set(value) {
    emit('update:checked', value)
  },
})
function listItemClickHandle(item: { label: string; value: string }) {
  checked.value = item.value
}
let propsComputed = computed(() => {
  return props
})
function confirmHandle() {
  emit('confirm', checked.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(propsComputed).data, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["reissue-type-list-item", { 'van-hairline--bottom': true, success: _unref(checked) === item.value }]),
            onClick: ($event: any) => (listItemClickHandle(item)),
            key: index
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(item.label), 1)
            ]),
            _createElementVNode("div", {
              onClick: ($event: any) => (listItemClickHandle(item))
            }, [
              _createVNode(_unref(RadioGroup), {
                modelValue: _unref(checked),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(checked) ? (checked).value = $event : checked = $event)),
                direction: "horizontal",
                "checked-color": "rgba(0, 195, 120, 1)",
                "icon-size": 24,
                class: "radio-group"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Radio), {
                    name: item.value
                  }, {
                    icon: _withCtx(({ checked }) => [
                      checked
                        ? (_openBlock(), _createBlock(_unref(Icon), {
                            key: 0,
                            name: _unref(SelectSvg),
                            size: "24"
                          }, null, 8, ["name"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["name"])
                ]),
                _: 2
              }, 1032, ["modelValue"])
            ], 8, _hoisted_6)
          ], 10, _hoisted_3))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_unref(Button), {
        class: "ok-button",
        color: "rgba(0, 195, 120, 1)",
        onClick: confirmHandle
      }, {
        default: _withCtx(() => [
          _createTextVNode("确定")
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})